export default __webpack_public_path__ + "static/B0055-8ce757430ba6e4e06149f9403594e80c.png";